import { render, staticRenderFns } from "./ProjectLayoutAside.vue?vue&type=template&id=6f341bae&scoped=true&"
import script from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
export * from "./ProjectLayoutAside.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectLayoutAside.vue?vue&type=style&index=0&id=6f341bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f341bae",
  null
  
)

export default component.exports